/* eslint-disable import/prefer-default-export */
export const openNewTab = (url) => {
    window.open(url, '_blank');
};
